import { ReactNode } from 'react';

export interface IWithCustomProps {
  children?: ReactNode;
  isCustom?: boolean;
  onCustomizationRemoved?: () => void;
}

export const WithCustom = (props: IWithCustomProps) => {
  function handleClick() {
    if (props.onCustomizationRemoved) {
      props.onCustomizationRemoved();
    }
  }
  return props.isCustom === true ? (
    <div className="custom-field">
      <div className="input-group">
        <input data-e2e="custom-input" className="form-control" value="CUSTOM" disabled />
        <span className="input-group-addon" onClick={handleClick}>
          <a>
            <i data-e2e="custom-link" className="icon">
              close
            </i>
          </a>
        </span>
      </div>
    </div>
  ) : (
    <div>{props.children}</div>
  );
};
